import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AES } from 'crypto-js';
import profile_image from "../../../images/user/Default_pfp.png";
import { setUserRoleName } from "../../../features/users/usersSlice.js";
import userTypeName from "../../../constants/userType";
import { UserTableSkeleton } from '../UserComponents/UserTableSkeleton';
import { ReactComponent as FilterIcon } from '../../../images/icons/filterIcon.svg';
import { ReactComponent as ItemIcon } from '../../../images/icons/itemIcon.svg';

const MobileSortIcon = () => (
    <span className="mobile-sort-icon-custom sort-icon-wrap" style={{ display: 'inline-flex', flexDirection: 'column', gap: '2px', alignItems: 'center', justifyContent: 'center', marginLeft: '6px', verticalAlign: 'middle', lineHeight: 1, flexShrink: 0 }}>
        <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', color: '#405BFF', opacity: 1 }}>
            <path d="M1 4L4 1L7 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', color: '#405BFF', opacity: 1 }}>
            <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </span>
);

function RecentUsers({
    wiseBanks,
    wiseBanksLoading,
    wiseBanksError,
    paginatedTeams,
    isUpdating,
    RenderUserCTA,
    renderUserStatus,
    UseRenderMemberName,
    BankAccountVerification,
    currentPage,
    handlePageChange,
    totalPages,
    rowsPerPage,
    toggleFilterModal,
}) {
    const dispatch = useDispatch();
    const timeTableRef = useRef(null);
    const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth <= 767);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const tableEl = timeTableRef.current;
        const contentOuter =
            document.querySelector(".content-outer.My.Team") ||
            document.querySelector(".content-outer.Users");

        if (!isMobile || !tableEl || !contentOuter) {
            contentOuter?.classList.remove("myteam-hscroll-end", "users-hscroll-end");
            return undefined;
        }

        const endClass = contentOuter.matches(".content-outer.My.Team")
            ? "myteam-hscroll-end"
            : "users-hscroll-end";

        const updatePadding = () => {
            if (window.innerWidth > 767) {
                contentOuter.classList.remove("myteam-hscroll-end", "users-hscroll-end");
                return;
            }
            const maxScroll = tableEl.scrollWidth - tableEl.clientWidth;
            if (maxScroll <= 1) {
                contentOuter.classList.remove("myteam-hscroll-end", "users-hscroll-end");
                return;
            }
            // Use scrollLeft + clientWidth so subpixel / iOS scroll ends are detected reliably
            const distanceFromEnd = maxScroll - tableEl.scrollLeft;
            const nearEnd = distanceFromEnd <= 8;
            contentOuter.classList.toggle(endClass, nearEnd);
            if (nearEnd) {
                contentOuter.classList.remove(
                    endClass === "myteam-hscroll-end" ? "users-hscroll-end" : "myteam-hscroll-end"
                );
            }
        };

        tableEl.addEventListener("scroll", updatePadding, { passive: true });
        window.addEventListener("resize", updatePadding);
        const resizeObserver =
            typeof ResizeObserver !== "undefined" ? new ResizeObserver(updatePadding) : null;
        resizeObserver?.observe(tableEl);
        // Recheck after layout settles (fonts / sticky cols)
        requestAnimationFrame(updatePadding);
        const t = window.setTimeout(updatePadding, 100);

        return () => {
            window.clearTimeout(t);
            tableEl.removeEventListener("scroll", updatePadding);
            window.removeEventListener("resize", updatePadding);
            resizeObserver?.disconnect();
            contentOuter.classList.remove("myteam-hscroll-end", "users-hscroll-end");
        };
    }, [isMobile, paginatedTeams]);

    const handleUserClick = (rowData) => {
        localStorage.setItem('activeTab', '0');
        if (rowData.role_id?._id === userTypeName.Team_Manager) {
            dispatch(setUserRoleName(userTypeName.Team_Manager));
        } else {
            dispatch(setUserRoleName("otheruser"));
        }
    };

    return (
        <div className="card-outer1">
            {!isMobile ? (
                /* ========================================================================= */
                /* DESKTOP & TABLET VIEW (100% untouched original table)                     */
                /* ========================================================================= */
                <div className="card-outer">
                    <div className="card-outer-user">
                        <h3>Recent Users</h3>
                    </div>

                    <div className="time-table">
                        <table style={{ minWidth: "50rem", width: "100%", textAlign: "left" }} className={`${isUpdating ? "loading-fade" : ""}`} >
                            <thead>
                                <tr>
                                    <th style={{ minWidth: "300px" }}>User Name</th>
                                    <th>Email</th>
                                    <th>Job Title</th>
                                    <th>Recipient</th>
                                    <th>Bank Account</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {isUpdating ? (
                                    <UserTableSkeleton rows={rowsPerPage} />
                                ) : paginatedTeams?.length === 0 ? (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: "center" }}>No Data Available</td>
                                    </tr>
                                ) : (
                                    paginatedTeams.map((row, index) => (
                                        <tr key={row._id || index}>
                                            <td>
                                                <UseRenderMemberName rowData={row} />
                                            </td>
                                            <td>{row.email}</td>
                                            <td>{row.job_title}</td>
                                            <td>{row.user_wx_comapny?.wx_company || "N/A"}</td>
                                            <td>
                                                <BankAccountVerification
                                                    email={row.email}
                                                    wiseBanks={wiseBanks}
                                                    isLoading={wiseBanksLoading}
                                                    isError={wiseBanksError}
                                                />
                                            </td>
                                            <td>{renderUserStatus(row)}</td>
                                            <td>{RenderUserCTA(row)}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination - Only show if there are multiple pages */}
                    {paginatedTeams.length > 0 && totalPages > 1 && (
                        <>
                            {isUpdating ? (
                                <ul className="pagination">
                                    {currentPage > 1 && (
                                        <li className="back">
                                            <button disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                                                Back
                                            </button>
                                        </li>
                                    )}
                                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                        <li key={page} className={currentPage === page ? "active" : ""}>
                                            <button disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                                                {page}
                                            </button>
                                        </li>
                                    ))}
                                    {currentPage < totalPages && (
                                        <li className="next">
                                            <button disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                                                Next
                                            </button>
                                        </li>
                                    )}
                                </ul>
                            ) : (
                                <ul className="pagination">
                                    {currentPage > 1 && (
                                        <li className="back">
                                            <button onClick={() => handlePageChange(currentPage - 1)}>
                                                Back
                                            </button>
                                        </li>
                                    )}
                                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                        <li key={page} className={currentPage === page ? "active" : ""}>
                                            <button onClick={() => handlePageChange(page)}>{page}</button>
                                        </li>
                                    ))}
                                    {currentPage < totalPages && (
                                        <li className="next">
                                            <button onClick={() => handlePageChange(currentPage + 1)}>
                                                Next
                                            </button>
                                        </li>
                                    )}
                                </ul>
                            )}
                        </>
                    )}
                </div>
            ) : (
                /* ========================================================================= */
                /* MOBILE-ONLY VIEW (All columns horizontally scrollable)                    */
                /* ========================================================================= */
                <div className="invoice-outer">
                    <div className="card">
                        <div className="card-outer-user-mobile">
                            <h3 className="all-users-mobile-title">All Users</h3>
                            {toggleFilterModal && (
                                <button type="button" className="filters-mobile-btn" onClick={toggleFilterModal}>
                                    <span>Filters</span>
                                    <FilterIcon width="20" height="17" />
                                </button>
                            )}
                        </div>

                        <div className="time-table" ref={timeTableRef}>
                            <table style={{ textAlign: "left" }} className={`${isUpdating ? "loading-fade" : ""}`}>
                                <thead>
                                    <tr>
                                        <th className="sticky-col">
                                            <div className="mobile-header-cell-inner">
                                                <span>User Name</span>
                                                <MobileSortIcon />
                                            </div>
                                        </th>
                                        <th>
                                            <div className="mobile-header-cell-inner">
                                                <span>Email</span>
                                                <MobileSortIcon />
                                            </div>
                                        </th>
                                        <th>
                                            <div className="mobile-header-cell-inner">
                                                <span>Job Title</span>
                                                <MobileSortIcon />
                                            </div>
                                        </th>
                                        <th>
                                            <div className="mobile-header-cell-inner">
                                                <span>Recipient</span>
                                                <MobileSortIcon />
                                            </div>
                                        </th>
                                        <th>
                                            <div className="mobile-header-cell-inner">
                                                <span>Bank Account</span>
                                                <MobileSortIcon />
                                            </div>
                                        </th>
                                        <th>
                                            <div className="mobile-header-cell-inner">
                                                <span>Status</span>
                                                <MobileSortIcon />
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isUpdating ? (
                                        <UserTableSkeleton rows={rowsPerPage} />
                                    ) : paginatedTeams?.length === 0 ? (
                                        <tr>
                                            <td colSpan="7" style={{ textAlign: "center", padding: "24px" }}>No Data Available</td>
                                        </tr>
                                    ) : (
                                        paginatedTeams.map((row, index) => {
                                            const encryptedId = AES.encrypt(row._id, 'encryptionKey').toString();
                                            const encodedId = encodeURIComponent(encryptedId).replace(/\//g, '%2F');
                                            const fullName = row.first_name
                                                ? `${row.first_name} ${row.last_name || ""}`.trim()
                                                : row.company_first_name
                                                    ? `${row.company_first_name} ${row.company_last_name || ""}`.trim()
                                                    : `${row.company_name || "User"} (Company)`;
                                            const profileImgSrc = row.profile_image !== null && row.profile_image !== "null" && row.profile_image
                                                ? `/uploads/lowProfileImage/${row.profile_image}`
                                                : profile_image;

                                            return (
                                                <tr key={row._id || index}>
                                                    <td className="sticky-col">
                                                        <Link
                                                            to={`/user/profile/${encodedId}`}
                                                            className="mobile-user-row-link"
                                                            onClick={() => handleUserClick(row)}
                                                        >
                                                            <div className="mobile-user-avatar-info">
                                                                <img
                                                                    src={profileImgSrc}
                                                                    alt={fullName}
                                                                    className="mobile-user-avatar"
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.src = profile_image;
                                                                    }}
                                                                />
                                                                <span className="mobile-user-name-text">{fullName}</span>
                                                            </div>
                                                            <span className="mobile-chevron-icon">
                                                                <ItemIcon />
                                                            </span>
                                                        </Link>
                                                    </td>
                                                    <td className="mobile-user-email-cell">
                                                        <span>{row.email}</span>
                                                    </td>
                                                    <td>
                                                        <span>{row.job_title || "--"}</span>
                                                    </td>
                                                    <td>
                                                        <span>{row.user_wx_comapny?.wx_company || "N/A"}</span>
                                                    </td>
                                                    <td>
                                                        <BankAccountVerification
                                                            email={row.email}
                                                            wiseBanks={wiseBanks}
                                                            isLoading={wiseBanksLoading}
                                                            isError={wiseBanksError}
                                                        />
                                                    </td>
                                                    <td>
                                                        {renderUserStatus(row)}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination on mobile */}
                        {paginatedTeams.length > 0 && totalPages > 1 && (
                            <>
                                {isUpdating ? (
                                    <ul className="pagination">
                                        {currentPage > 1 && (
                                            <li className="back">
                                                <button disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                                                    Back
                                                </button>
                                            </li>
                                        )}
                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                            <li key={page} className={currentPage === page ? "active" : ""}>
                                                <button disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                                                    {page}
                                                </button>
                                            </li>
                                        ))}
                                        {currentPage < totalPages && (
                                            <li className="next">
                                                <button disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                                                    Next
                                                </button>
                                            </li>
                                        )}
                                    </ul>
                                ) : (
                                    <ul className="pagination">
                                        {currentPage > 1 && (
                                            <li className="back">
                                                <button onClick={() => handlePageChange(currentPage - 1)}>
                                                    Back
                                                </button>
                                            </li>
                                        )}
                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                            <li key={page} className={currentPage === page ? "active" : ""}>
                                                <button onClick={() => handlePageChange(page)}>{page}</button>
                                            </li>
                                        ))}
                                        {currentPage < totalPages && (
                                            <li className="next">
                                                <button onClick={() => handlePageChange(currentPage + 1)}>
                                                    Next
                                                </button>
                                            </li>
                                        )}
                                    </ul>
                                )}
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default RecentUsers;